export default __webpack_public_path__ + "static/ups_b.827f8d2bc5a341961f31b569214c3040.svg";